/**
 * Client-safe public configuration (`VITE_*`).
 *
 * Vite inlines only static `import.meta.env.VITE_*` references at build time.
 *
 * **Local:** `.env.development` + `npm run dev`.
 * **CI / production:** set the same vars before `npm run build`.
 */

const DEFAULT_BASE_URL = "https://node-envella.agiletechnologies.in/api";

function normalizeBaseUrl(raw: string): string {
  const trimmed = raw.trim();
  if (!trimmed) return DEFAULT_BASE_URL;
  if (trimmed.endsWith("/api")) return trimmed;
  return `${trimmed.replace(/\/$/, "")}/api`;
}

export const publicEnv = {
  baseUrl: normalizeBaseUrl(import.meta.env.VITE_BASE_URL ?? ""),
  redirectUrl: (import.meta.env.VITE_REDIRECT_URL ?? "").trim(),
  googleClientId: (import.meta.env.VITE_GOOGLE_CLIENT_ID ?? "").trim(),
  googlePlacesApiKey: (import.meta.env.GOOGLE_PLACES_API_KEY ?? "").trim(),
  appleClientId: (import.meta.env.VITE_APPLE_CLIENT_ID ?? "").trim(),
  appleRedirectUri: (import.meta.env.VITE_APPLE_REDIRECT_URI ?? "").trim(),
} as const;

export const isGoogleSignInConfigured =
  publicEnv.googleClientId.length > 0 &&
  publicEnv.googleClientId.endsWith(".apps.googleusercontent.com");

export const isAppleSignInConfigured = publicEnv.appleClientId.length > 0;
